/**
 * HistoryPayloadComponent created by karora on 02/01/18.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from "../app.component";
import {Router} from "@angular/router";

/*
{
    "accuracy": null,
    "annual": {
        "budget": null,
        "minutes": 0,
        "saving": null,
        "spend": null,
        "units": null,
        "year": 2018
    },
    "centsperunit": null,
    "days": null,
    "offset": 0,
    "spendmode": "learning",
    "timestamp": "2018-01-02T10:37:34.479Z",
    "unitsperminute": 0.00738
}
*/

class annualHistory {
  budget: number;
  minutes: number;
  saving: number;
  spend: number;
  units: number;
  year: number;
}
class spendHistory {
  accuracy: number;
  annual: annualHistory;
  annualString: string;
  centsperunit: number;
  days: number;
  offset: number;
  spendmode: string;
  timestamp: string;
  unitsperminute: number;
}

@Component({
  selector: 'history-payload',
  template: `
    <div id="history" *ngIf="payload && payload != '[]'">
      <span class="prompt">Acc.:</span><span class="number">{{rec.accuracy}}</span>
      <span class="prompt">c/X:</span><span class="number">{{rec.centsperunit}}</span>
      <span class="prompt">X/min:</span><span class="number">{{rec.unitsperminute}}</span>
      <span class="prompt">Mode:</span><span class="mode">{{rec.spendmode}}</span>
      <span class="prompt">Offset:</span><span class="number">{{rec.offset}}</span><br/>
      <span class="prompt">Days:</span><span class="string">{{rec.days}}</span><br/>
      <span class="prompt">Annual:</span><span class="string">{{annualString}}</span>
    </div>`,
  styles: [
    'span { color: black; display: inline-block}',
    '.hubrow {width: inherit;   word-wrap: break-word; display: block}',
    '.hubrow:hover { background-color: bisque}',
    '.prompt { font-weight: lighter; width: 3em; color: #444444;}',
    '.number { font-weight: bold; width: 4.2em; text-align: right;}',
    '.mode {width: 4em; }',
    '.string { word-break: break-all;}'
  ]
})

export class HistoryPayloadComponent implements OnInit {
  @Input() payload: any;
  rec: spendHistory;
  annualString: string;
  errorMessage: string;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) return;
    this.rec = <spendHistory>this.payload;
    this.annualString = JSON.stringify(this.rec.annual);
  }
}
